import { HTTP } from '../helpers/http-common.js'
import authHeader from '../helpers/auth-header'
import helpers from '../helpers/helpers'


const inventoriesService = {
    getProviders,
    storeProvider,
    updateProvider,
    getProvider,
    deleteProvider,
    getItemProviders,
    storeItemProvider,
    updateItemProvider,
    getItemProvider,
    deleteItemProvider,
    getInventory,
    storeInventory
};

export default inventoriesService

function getProviders(page = 0, search = {}) {

  let params = '';
  
  if(search.term) {
    params += `&search=${search.term}`;
  }

  if(search.options) {
    params += `&options=${search.options}`
  }

  if(search.perPage) {
    params += `&perPage=${search.perPage}`
  }

  return HTTP.get(`inventory-providers?page=${page}${params}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function getProvider(id) {
  return HTTP.get(`inventory-provider/${id}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function storeProvider(item = {}) {
  return HTTP({
    method: 'post',
    url: 'store-inventory-provider',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function updateProvider(item = {}) {
  return HTTP({
    method: 'post',
    url: 'update-inventory-provider',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function deleteProvider(id) {
  return HTTP({
    method: 'post',
    url: 'delete-inventory-provider',
    data: {id: id},
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function getItemProviders(id, page = 0, search = {}) {

    let params = '';
    
    if(search.term) {
      params += `&search=${search.term}`;
    }
  
    if(search.options) {
      params += `&options=${search.options}`
    }
  
    if(search.perPage) {
      params += `&perPage=${search.perPage}`
    }
  
    return HTTP.get(`item-providers/${id}?page=${page}${params}`, {
      headers: {
        'Authorization': authHeader(),
        'x-Company': helpers.getCompanyId()
      }
    });
  }
  
  function getItemProvider(id) {
    return HTTP.get(`item-provider/${id}`, {
      headers: {
        'Authorization': authHeader(),
        'x-Company': helpers.getCompanyId()
  
      }
    });
  }
  
  function storeItemProvider(item = {}) {
    return HTTP({
      method: 'post',
      url: 'store-item-provider',
      data: item,
      headers: {
        'Authorization': authHeader(),
        'x-Company': helpers.getCompanyId()
  
      }
    });
  }
  
  function updateItemProvider(item = {}) {
    return HTTP({
      method: 'post',
      url: 'update-item-provider',
      data: item,
      headers: {
        'Authorization': authHeader(),
        'x-Company': helpers.getCompanyId()
      }
    });
  }
  
  function deleteItemProvider(id) {
    return HTTP({
      method: 'post',
      url: 'delete-item-provider',
      data: {id: id},
      headers: {
        'Authorization': authHeader(),
        'x-Company': helpers.getCompanyId()
      }
    });
  }

  function getInventory(id) {
    return HTTP.get(`inventory/${id}`, {
      headers: {
        'Authorization': authHeader(),
        'x-Company': helpers.getCompanyId()
  
      }
    });
  }

  function storeInventory(item = {}) {
    return HTTP({
      method: 'post',
      url: 'store-inventory',
      data: item,
      headers: {
        'Authorization': authHeader(),
        'x-Company': helpers.getCompanyId()
  
      }
    });
  }
